import { render, staticRenderFns } from "./SnookerRuleDialog.vue?vue&type=template&id=31e329d8&"
import script from "./SnookerRuleDialog.vue?vue&type=script&lang=js&"
export * from "./SnookerRuleDialog.vue?vue&type=script&lang=js&"
import style0 from "./SnookerRuleDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports